import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=c01dc8ea&scoped=true"
import script from "./announcement.vue?vue&type=script&lang=js"
export * from "./announcement.vue?vue&type=script&lang=js"
import style0 from "./announcement.vue?vue&type=style&index=0&id=c01dc8ea&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01dc8ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c01dc8ea')) {
      api.createRecord('c01dc8ea', component.options)
    } else {
      api.reload('c01dc8ea', component.options)
    }
    module.hot.accept("./announcement.vue?vue&type=template&id=c01dc8ea&scoped=true", function () {
      api.rerender('c01dc8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/announcement.vue"
export default component.exports